export default __webpack_public_path__ + "media/assets/fonts/roboto-v20-latin-500italic-88393bfdfb9775432a44e09b73ba2d5b.eot";